module.exports = __webpack_public_path__ + "static/home-image-5-ed0309714820f2a5dd136db391868f38.jpg";